import _ from 'lodash';
import { getLegs as getDeliveryLegs } from '../../libs/deliveryLegs';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import FMPHeadline from '../../components/ui/FMPHeadline';
import StationInvoicesContainer from '../../containers/accounting/StationInvoices';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import InvoiceDocumentIcon from '../../components/ui/invoiceDocumentIcon';
import InvoiceDocumentPopup from '../../components/Dialogs/InvoiceDocumentPopup';
import InvoicePdfPopup from '../../components/Dialogs/InvoicePdfPopup';
import PendingIcon from '@material-ui/icons/AccessTime';
import InvalidIcon from '@material-ui/icons/DeleteForever';
import SentIcon from '@material-ui/icons/Send';
import invoiceIcon from '../../images/invoicePdf.svg';
import quickbooksLogo from '../../images/quickbooksLogo.svg';
import ViewStationInvoiceLogDialog from '../../components/Dialogs/ViewStationInvoiceLogDialog';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Typography from '@material-ui/core/Typography';

import { isFiltered, sortTable, PureRecordRow } from '../../libs/utility';
import {
	MANUAL_PRICE_ORANGE,
	MANUAL_PRICE_BORDER,
	MANUAL_PRICE_BACKGROUND,
} from '../../components/ManualPriceNotice';
import { getDocuments, invoiceStatusClassNames, statusToDisplay, moneyFormatter } from './general';

import { valueToAbbreviation } from '../../libs/products';

const styles = (theme) => ({
	...invoiceStatusClassNames,
	paper: {
		width: '100%',
		overflowX: 'auto',
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 20,
		[theme.breakpoints.up('md')]: {
			padding: '10px 20px 20px 20px',
		},
		borderRadius: 0,
	},
	table: {
		width: '100%',
		tableLayout: 'auto',
	},
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	stats: {
		padding: '20px 10px 20px 10px',
		borderBottom: '1px solid #ddd',
		marginBottom: 10,
	},
	statGroup: {
		padding: '5px 5px 10px 5px',
		borderBottom: '1px solid #eee',
		marginBottom: 10,
	},
	available: {
		fontWeight: 900,
	},
	invoiceDocument: {
		position: 'absolute',
	},
	invoiceDocumentContainer: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
	quickbooksIcon: {
		display: 'inline-block',
		width: 40,
		height: 40,
		backgroundImage: `url('${quickbooksLogo}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

//const columnStyle = { whiteSpace : 'nowrap' };
const pendingColumns = [
	{
		id: 'stationInvoiceId',
		label: 'Invoice #',
	},
	{
		id: 'productTypeAbbreviation',
		label: 'Fuel',
	},
	{
		id: 'stationDisplay',
		label: 'Station',
	},
	{
		id: 'deliveryId',
		label: 'Delivery #',
	},
	{
		id: 'deliveryDateSort',
		label: 'Delivery Date',
	},
	{
		id: 'deliveryInfo',
		label: 'Delivery Info',
	},
	{
		id: 'documentInfo',
		label: 'Documents',
	},
	{
		id: 'status',
		label: 'Status',
	},
	{
		id: 'edit',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const invalidColumns = pendingColumns;

const issuedColumns = [
	{
		id: 'stationInvoiceId',
		label: 'Invoice #',
	},
	{
		id: 'productTypeAbbreviation',
		label: 'Fuel',
	},
	{
		id: 'deliveryInfo',
		label: 'Delivery Info',
	},
	{
		id: 'issueDateSort',
		label: 'Invoice Info',
	},
	{
		id: 'invoiceInfo',
		label: 'Invoice Fuels',
	},
	{
		id: 'documentInfo',
		label: 'Documents',
	},
	{
		id: 'invoicePdf',
		label: 'Invoice PDF',
	},
	{
		id: 'quickbooksInvoiceUrl',
		label: 'QB Url',
	},
	{
		id: 'status',
		label: 'Status',
	},
	{
		id: 'edit',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

//- Flags invoices whose fuel price was typed in by hand instead of the quoted price
function withManualPriceTag(statusDisplay, stationInvoice) {
	if (_.isNil(stationInvoice.manualPricePerGallon)) {
		return statusDisplay;
	}
	return (
		<Fragment>
			{statusDisplay}
			<div style={MANUAL_PRICE_TAG_STYLE}>Manual price</div>
		</Fragment>
	);
}

const MANUAL_PRICE_TAG_STYLE = {
	display: 'inline-block',
	marginTop: 3,
	padding: '1px 6px',
	borderRadius: 10,
	fontSize: 11,
	color: MANUAL_PRICE_ORANGE,
	backgroundColor: MANUAL_PRICE_BACKGROUND,
	border: `1px solid ${MANUAL_PRICE_BORDER}`,
};

class StationInvoices extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'pending');

		const startingTabIndex =
			{
				pending: 0,
				issued: 1,
				invalid: 2,
			}[startingTab] || 0;

		this.state = {
			tabIndex: startingTabIndex,
			pendingOrder: 'asc',
			pendingOrderBy: 'deliveryDateSort',
			invalidOrder: 'asc',
			invalidOrderBy: 'deliveryDateSort',
			issuedOrder: 'desc',
			issuedOrderBy: 'stationInvoiceId',
			search: '',
			filterMap: {},
			isViewDialogOpen: false,
			viewStationInvoice: undefined,
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,

			pendingRows: undefined,
			invalidRows: undefined,
			issuedRows: undefined,
		};
	}

	componentDidMount() {
		const { pendingStationInvoices, invalidStationInvoices, issuedStationInvoices } = this.props;
		const {
			pendingOrder,
			pendingOrderBy,
			invalidOrder,
			invalidOrderBy,
			issuedOrder,
			issuedOrderBy,
		} = this.state;

		const newState = {};

		if (!pendingStationInvoices) {
			this.props.searchStationInvoices({
				status: 'pending',
			});
		} else {
			const data = this.formatPendingAndInvalidStationInvoices({
				stationInvoices: this.props.pendingStationInvoices,
				statusType: 'pending',
			});
			newState.pendingRows = sortTable({ data, order: pendingOrder, orderBy: pendingOrderBy });
		}

		if (!invalidStationInvoices) {
			this.props.searchStationInvoices({
				status: 'invalid',
				afterDate: moment().subtract(20, 'days').format('YYYY-MM-DD'),
			});
			//- No afterDate: the window filters on deliveryDate, and credits often fix
			//- invoices for deliveries older than any recent window. Credited rows are rare.
			this.props.searchStationInvoices({
				status: 'credited',
			});
		} else {
			const data = this.formatPendingAndInvalidStationInvoices({
				stationInvoices: this.props.invalidStationInvoices,
				statusType: 'invalid',
			});
			newState.invalidRows = sortTable({ data, order: invalidOrder, orderBy: invalidOrderBy });
		}

		if (!issuedStationInvoices) {
			this.props.searchStationInvoices({
				status: 'issued',
				afterDate: moment().subtract(20, 'days').format('YYYY-MM-DD'),
			});
		} else {
			const data = this.formatIssuedStationInvoices({
				stationInvoices: this.props.issuedStationInvoices,
			});
			newState.issuedRows = sortTable({ data, order: issuedOrder, orderBy: issuedOrderBy });
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			pendingOrder,
			pendingOrderBy,
			invalidOrder,
			invalidOrderBy,
			issuedOrder,
			issuedOrderBy,
		} = this.state;

		const newState = {};

		//- Format the rows when you first get them or they change
		if (prevProps.pendingStationInvoices !== this.props.pendingStationInvoices) {
			const data = this.formatPendingAndInvalidStationInvoices({
				stationInvoices: this.props.pendingStationInvoices,
				statusType: 'pending',
			});
			newState.pendingRows = sortTable({ data, order: pendingOrder, orderBy: pendingOrderBy });
		}

		//- Format the rows when you first get them or they change
		if (prevProps.invalidStationInvoices !== this.props.invalidStationInvoices) {
			const data = this.formatPendingAndInvalidStationInvoices({
				stationInvoices: this.props.invalidStationInvoices,
				statusType: 'invalid',
			});
			newState.invalidRows = sortTable({ data, order: invalidOrder, orderBy: invalidOrderBy });
		}

		if (prevProps.issuedStationInvoices !== this.props.issuedStationInvoices) {
			const data = this.formatIssuedStationInvoices({
				stationInvoices: this.props.issuedStationInvoices,
			});
			newState.issuedRows = sortTable({ data, order: issuedOrder, orderBy: issuedOrderBy });
		}

		//- Sort
		if (prevState.pendingOrder !== pendingOrder || prevState.pendingOrderBy !== pendingOrderBy) {
			newState.pendingRows = sortTable({
				data: this.state.pendingRows,
				order: pendingOrder,
				orderBy: pendingOrderBy,
			});
		}

		if (prevState.invalidOrder !== invalidOrder || prevState.invalidOrderBy !== invalidOrderBy) {
			newState.invalidRows = sortTable({
				data: this.state.invalidRows,
				order: invalidOrder,
				orderBy: invalidOrderBy,
			});
		}

		if (prevState.issuedOrder !== issuedOrder || prevState.issuedOrderBy !== issuedOrderBy) {
			newState.issuedRows = sortTable({
				data: this.state.issuedRows,
				order: issuedOrder,
				orderBy: issuedOrderBy,
			});
		}

		//- Type to search needs to filter
		if (prevState.search !== this.state.search) {
			newState.filterMap = this.getFilterMap();
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	getDocumentInfo = (uploadedInvoiceDocuments) => {
		const { classes, resourceMap } = this.props;

		if (_.isEmpty(uploadedInvoiceDocuments)) {
			return 'None yet';
		}

		//- Documents
		let left = 0;
		let zIndex = 100;
		return (
			<div
				className={classes.invoiceDocumentContainer}
				onClick={() => {
					this.onDocumentClick(uploadedInvoiceDocuments);
				}}
			>
				{uploadedInvoiceDocuments.map((invoiceDocument, i) => {
					left = i * 10;
					zIndex--;
					return (
						<div className={classes.invoiceDocument} style={{ left, zIndex }} key={i}>
							<InvoiceDocumentIcon
								hasTooltip={false}
								invoiceDocument={invoiceDocument}
								resourceMap={resourceMap}
								onClick={_.noop}
							/>
						</div>
					);
				})}
			</div>
		);
	};

	formatPendingAndInvalidStationInvoices = ({ stationInvoices, statusType }) => {
		const ret = [];

		stationInvoices.forEach((stationInvoice) => {
			const {
				stationMap,
				carrierMap,
				invoiceDocumentMap,
				stationDeliveryMap,
				terminalMap,
				//resourceMap,
				supplierMap,
			} = this.props;

			const {
				stationInvoiceId,
				linkedStationDeliveryId,
				productType,
				deliveryDate,
				stationId,
				carrierId,
				//status,
				invoiceDocumentIds,
				dateCreated,
			} = stationInvoice;

			let status = stationInvoice.status;

			const station = stationMap[stationId] || { number: '', name: 'MISSING STATION' };

			const stationDisplay = `${station.number} - ${station.name}`;
			const productTypeAbbreviation = valueToAbbreviation(productType);

			//- Delivery
			let stationDelivery;
			let deliveryMoment = moment(deliveryDate || dateCreated);

			let deliveryId = <span>No Delivery</span>;
			let deliveryInfo = <span>Not Linked</span>;

			//- Got a delivery
			if (linkedStationDeliveryId) {
				stationDelivery = stationDeliveryMap[linkedStationDeliveryId];

				if (!stationDelivery) {
					deliveryInfo = <span>Delivery {linkedStationDeliveryId} not found</span>;
				} else {
					const { carrierId, deliveryWindowEndDateTime, stationDeliveryId } = stationDelivery;

					//const productTypeDisplay = valueToDisplay(productType);

					//- Sum the invoice station's stops (tank splits count both tanks)
					const stationLegs = getDeliveryLegs(stationDelivery).filter(
						(leg) => leg.stationId === stationId
					);
					let totalFuel;
					if (stationLegs.length) {
						totalFuel = stationLegs.reduce((sum, leg) => sum + (leg.deliveryAmount || 0), 0);
					} else {
						totalFuel = `StationId:${stationId} does not match any stop on delivery`;
					}

					const carrier = carrierMap[carrierId] || { name: 'MISSING CARRIER' };
					deliveryMoment = moment(deliveryWindowEndDateTime);

					//const dateDisplay = moment(deliveryWindowEndDateTime).format('ddd, M/D');
					//deliveryInfoOrder = moment(deliveryWindowEndDateTime).format('YYYY-MM-DD');

					deliveryId = stationDeliveryId;
					deliveryInfo = (
						<Fragment>
							<div>{carrier.name}</div>
							<div>
								{totalFuel} gallons {productTypeAbbreviation}
							</div>
						</Fragment>
					);
				}
			}

			let deliveryDateSort = deliveryMoment.format('YYYY-MM-DD');
			let deliveryDateDisplay = deliveryMoment.format('ddd, M/D');

			//- Station Invoice
			const invoiceDocuments = invoiceDocumentIds.map((invoiceDocumentId) => {
				return invoiceDocumentMap[invoiceDocumentId] || { name: 'MISSING' };
			});

			const { uploadedInvoiceDocuments } = getDocuments({
				stationDelivery,
				carrierMap,
				terminalMap,
				supplierMap,
				invoiceDocuments,
			});

			let documentInfo = this.getDocumentInfo(uploadedInvoiceDocuments);

			const fourDaysAgo = moment().subtract(4, 'days');
			const sixDaysAgo = moment().subtract(6, 'days');

			//- filter out the old invalid invoices
			//if (status === 'invalid' && deliveryMoment.isBefore(sixDaysAgo)) {
			//	return;
			//}

			if (status === 'pending' && deliveryMoment.isBefore(sixDaysAgo)) {
				status = 'pendingVeryOld';
			} else if (status === 'pending' && deliveryMoment.isBefore(fourDaysAgo)) {
				status = 'pendingOld';
			}

			const statusDisplay =
				{
					pending: 'Pending',
					issued: 'Issued',
					sent: 'Sent (Missing QB)',
					credited: 'Credited',
					pendingOld: (
						<Fragment>
							<div>Pending</div>
							<div>(4+ days old)</div>
						</Fragment>
					),
					pendingVeryOld: (
						<Fragment>
							<div>Pending!</div>
							<div>(6+ days old)</div>
						</Fragment>
					),
				}[status] || status;

			ret.push({
				stationInvoiceId,
				stationDisplay,
				productTypeAbbreviation,

				deliveryId,
				deliveryDateDisplay,
				deliveryDateSort,
				deliveryInfo,

				documentInfo,

				linkedStationDeliveryId,
				stationId,
				carrierId,
				status,
				statusDisplay: withManualPriceTag(statusDisplay, stationInvoice),
				rowClick: () => {
					this.handleRowClick(stationInvoiceId, statusType);
				},
			});
		});
		return ret;
	};

	formatIssuedStationInvoices = ({ stationInvoices }) => {
		return stationInvoices.map((stationInvoice) => {
			const {
				stationMap,
				carrierMap,
				invoiceDocumentMap,
				stationDeliveryMap,
				terminalMap,
				//resourceMap,
				supplierMap,
			} = this.props;

			const {
				stationInvoiceId,
				productType,
				linkedStationDeliveryId,
				stationId,
				carrierId,
				status,
				//deliveryWindowEndDateTime,
				invoiceDocumentIds,
				issueDate,
				//dateCreated,
				collatedResourceId,
				quickbooksInvoiceUrl,
			} = stationInvoice;

			const station = stationMap[stationId] || { number: '', name: 'MISSING STATION' };
			const stationDisplay = `${station.number} - ${station.name}`;
			const productTypeAbbreviation = valueToAbbreviation(productType);

			//- Delivery
			let stationDelivery;
			let deliveryInfo = <span>Not linked</span>;
			if (linkedStationDeliveryId) {
				stationDelivery = stationDeliveryMap[linkedStationDeliveryId];
				if (!stationDelivery) {
					deliveryInfo = <span>Delivery {linkedStationDeliveryId} not found</span>;
				} else {
					const { deliveryWindowEndDateTime, stationDeliveryId } = stationDelivery;

					const dateDisplay = moment(deliveryWindowEndDateTime).format('ddd, M/D');
					deliveryInfo = (
						<Fragment>
							<div>{stationDisplay}</div>
							<div>Delivery #{stationDeliveryId}</div>
							<div>{dateDisplay}</div>
						</Fragment>
					);
				}
			}

			//- Station Invoice
			const invoiceDocuments = invoiceDocumentIds.map((invoiceDocumentId) => {
				return invoiceDocumentMap[invoiceDocumentId] || { name: 'MISSING' };
			});

			const { uploadedInvoiceDocuments, missingInvoiceDocuments } = getDocuments({
				stationDelivery,
				carrierMap,
				terminalMap,
				supplierMap,
				invoiceDocuments,
			});

			//- InvoiceInfo
			const invoiceLines = [];
			if (!_.isEmpty(missingInvoiceDocuments)) {
				invoiceLines.push('No documents yet');
			} else {
				const { products } = stationInvoice;
				if (_.isEmpty(products)) {
					invoiceLines.push('No fuels yet');
				} else {
					products.forEach((product) => {
						const { productType, terminalSupplier, netGallons } = product;
						let terminalDisplay = 'No terminal yet';
						if (terminalSupplier) {
							const terminal = terminalMap[terminalSupplier.terminalId] || {
								name: `Missing terminal : ${terminalSupplier.terminalId}`,
							};
							terminalDisplay = terminal.name;
						}
						invoiceLines.push(`${netGallons} ${productType} : ${terminalDisplay}`);
					});
				}
			}

			const carrier = carrierMap[carrierId] || { name: 'MISSING CARRIER' };
			let invoiceFuels = (
				<Fragment>
					<div>{carrier.name}</div>
					{invoiceLines.map((line, i) => {
						return <div key={i}>{line}</div>;
					})}
				</Fragment>
			);

			//- Documents
			let documentInfo = this.getDocumentInfo(uploadedInvoiceDocuments);
			const statusDisplay = statusToDisplay[status] || status;

			let issueMoment = moment(issueDate);
			let issueDateSort = issueMoment.format('YYYY-MM-DD');
			let issueDateDisplay = issueMoment.format('ddd, M/D');

			let invoicePdf = 'PDF';
			let onInvoiceClick = () => {
				this.onInvoiceClick(collatedResourceId);
			};
			let invoiceTotal = <span>{moneyFormatter.format(stationInvoice.total)}</span>;
			let invoiceInfo = (
				<Fragment>
					<div>Issued : {issueDateDisplay}</div>
					<div>Total : {invoiceTotal}</div>
				</Fragment>
			);

			return {
				stationInvoiceId,
				deliveryInfo,
				productTypeAbbreviation,
				issueDateSort,
				issueDateDisplay,
				invoiceTotal,
				invoiceInfo,
				invoiceFuels,
				documentInfo,
				invoicePdf,
				quickbooksInvoiceUrl,
				onInvoiceClick,
				linkedStationDeliveryId,
				stationId,
				carrierId,
				status,
				statusDisplay: withManualPriceTag(statusDisplay, stationInvoice),
				rowClick: () => {
					this.handleRowClick(stationInvoiceId, 'issued');
				},
			};
		});
	};

	getFilterMap = () => {
		const { search, pendingRows, invalidRows, issuedRows } = this.state;
		const filterMap = {};
		pendingRows.concat(invalidRows, issuedRows).forEach((row) => {
			if (
				isFiltered({
					search,
					data: row,
					fields: ['stationInvoiceId', 'stationDisplay', 'deliveryId'],
				})
			) {
				filterMap[row.stationInvoiceId] = true;
			}
		});
		return filterMap;
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handlePendingSort = (orderBy) => {
		let order = 'desc';
		if (this.state.pendingOrderBy === orderBy && this.state.pendingOrder === 'desc') {
			order = 'asc';
		}
		this.setState({ pendingOrder: order, pendingOrderBy: orderBy });
	};

	handleInvalidSort = (orderBy) => {
		let order = 'desc';
		if (this.state.invalidOrderBy === orderBy && this.state.invalidOrder === 'desc') {
			order = 'asc';
		}
		this.setState({ invalidOrder: order, invalidOrderBy: orderBy });
	};

	handleIssuedSort = (orderBy) => {
		let order = 'desc';
		if (this.state.issuedOrderBy === orderBy && this.state.issuedOrder === 'desc') {
			order = 'asc';
		}
		this.setState({ issuedOrder: order, issuedOrderBy: orderBy });
	};

	handleEdit = (stationInvoiceId) => {
		this.props.history.push(`/accounting/stationInvoice/update/${stationInvoiceId}`);
	};

	handleRowClick = (stationInvoiceId, type) => {
		let viewStationInvoice;

		if (type === 'pending') {
			const { pendingStationInvoices } = this.props;
			viewStationInvoice = _.find(pendingStationInvoices, { stationInvoiceId });
		} else if (type === 'invalid') {
			const { invalidStationInvoices } = this.props;
			viewStationInvoice = _.find(invalidStationInvoices, { stationInvoiceId });
		} else if (type === 'issued') {
			const { issuedStationInvoices } = this.props;
			viewStationInvoice = _.find(issuedStationInvoices, { stationInvoiceId });
		}
		this.setState({
			viewStationInvoice,
			isViewDialogOpen: true,
		});
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen: false,
			viewStationInvoice: undefined,
		});
	};

	handleCloseInvoiceDocumentPopup = () => {
		this.setState({
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
		});
	};

	onDocumentClick = (invoiceDocuments) => {
		this.setState({
			isInvoiceDocumentPopupOpen: true,
			invoiceDocumentsPoppedUp: invoiceDocuments,
		});
	};

	onInvoiceClick = (resourceId) => {
		this.setState({
			isInvoicePdfPopupOpen: true,
			invoicePdfPoppedUp: resourceId,
		});
	};

	handleCloseInvoicePdfPopup = () => {
		this.setState({
			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,
		});
	};

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	render() {
		const { classes, canMakeUpdates, resourceMap, theme } = this.props;

		const {
			pendingRows,
			invalidRows = [],
			issuedRows,
			pendingOrder,
			pendingOrderBy,
			invalidOrder,
			invalidOrderBy,
			issuedOrder,
			issuedOrderBy,
			filterMap,
		} = this.state;

		if (!pendingRows || !issuedRows) {
			return <div>Loading the station invoices...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Station Invoices"
						value={this.state.search}
						onChange={this.handleSearch}
						canMakeUpdates={canMakeUpdates}
					/>

					<AppBar position="static" color="default">
						<Tabs
							value={this.state.tabIndex}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							centered
						>
							<Tab label="All Pending" icon={<PendingIcon />} />
							<Tab label="Recently Issued" icon={<SentIcon />} />
							<Tab label="Recently Invalid / Credited" icon={<InvalidIcon />} />
						</Tabs>
					</AppBar>
					<Paper className={classes.paper}>
						<SwipeableViews
							axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
							index={this.state.tabIndex}
							onChangeIndex={this.handleChangeTabIndex}
						>
							<TabContainer dir={theme.direction}>
								<Table size="small" stickyHeader>
									<EnhancedTableHead
										columnData={pendingColumns}
										order={pendingOrder}
										orderBy={pendingOrderBy}
										onRequestSort={this.handlePendingSort}
									/>
									<TableBody>
										{pendingRows.map((row) => {
											if (filterMap[row.stationInvoiceId]) {
												return null;
											}

											return (
												<PureRecordRow hover className={classes.row} key={row.stationInvoiceId}>
													<TableCell onClick={row.rowClick}>{row.stationInvoiceId}</TableCell>
													<TableCell onClick={row.rowClick}>
														{row.productTypeAbbreviation}
													</TableCell>
													<TableCell onClick={row.rowClick}>{row.stationDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.deliveryId}</TableCell>
													<TableCell onClick={row.rowClick}>{row.deliveryDateDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.deliveryInfo}</TableCell>
													<TableCell>{row.documentInfo}</TableCell>
													<TableCell
														onClick={row.rowClick}
														className={classes[row.status]}
														style={{ whiteSpace: 'nowrap' }}
													>
														{row.statusDisplay}
													</TableCell>

													{canMakeUpdates && (
														<TableCell style={{ whiteSpace: 'nowrap' }}>
															<Button
																className={classes.button}
																onClick={() => this.handleEdit(row.stationInvoiceId)}
															>
																Edit
															</Button>
														</TableCell>
													)}
												</PureRecordRow>
											);
										})}
									</TableBody>
								</Table>
							</TabContainer>
							<TabContainer dir={theme.direction}>
								<Table size="small" className={classes.table}>
									<EnhancedTableHead
										columnData={issuedColumns}
										order={issuedOrder}
										orderBy={issuedOrderBy}
										onRequestSort={this.handleIssuedSort}
									/>
									<TableBody>
										{issuedRows.map((row) => {
											if (filterMap[row.stationInvoiceId]) {
												return null;
											}
											return (
												<PureRecordRow hover className={classes.row} key={row.stationInvoiceId}>
													<TableCell onClick={row.rowClick}>{row.stationInvoiceId}</TableCell>
													<TableCell onClick={row.rowClick}>
														{row.productTypeAbbreviation}
													</TableCell>
													<TableCell onClick={row.rowClick}>{row.deliveryInfo}</TableCell>
													<TableCell onClick={row.rowClick}>{row.invoiceInfo}</TableCell>
													<TableCell onClick={row.rowClick}>{row.invoiceFuels}</TableCell>

													<TableCell>{row.documentInfo}</TableCell>
													<TableCell>
														<div className={classes.invoiceIcon} onClick={row.onInvoiceClick} />
													</TableCell>

													<TableCell>
														<a
															href={row.quickbooksInvoiceUrl}
															target="_blank"
															rel="noreferrer noopener"
														>
															<div className={classes.quickbooksIcon} />
														</a>
													</TableCell>

													<TableCell
														onClick={row.rowClick}
														className={classes[row.status]}
														style={{ whiteSpace: 'nowrap' }}
													>
														{row.statusDisplay}
													</TableCell>

													{canMakeUpdates && (
														<TableCell style={{ whiteSpace: 'nowrap' }}>
															<Button
																className={classes.button}
																onClick={() => this.handleEdit(row.stationInvoiceId)}
															>
																Edit
															</Button>
														</TableCell>
													)}
												</PureRecordRow>
											);
										})}
									</TableBody>
								</Table>
							</TabContainer>

							<TabContainer dir={theme.direction}>
								<Table size="small" className={classes.table}>
									<EnhancedTableHead
										columnData={invalidColumns}
										order={invalidOrder}
										orderBy={invalidOrderBy}
										onRequestSort={this.handleInvalidSort}
									/>
									<TableBody>
										{invalidRows.map((row) => {
											if (filterMap[row.stationInvoiceId]) {
												return null;
											}

											return (
												<PureRecordRow hover className={classes.row} key={row.stationInvoiceId}>
													<TableCell onClick={row.rowClick}>{row.stationInvoiceId}</TableCell>
													<TableCell onClick={row.rowClick}>
														{row.productTypeAbbreviation}
													</TableCell>
													<TableCell onClick={row.rowClick}>{row.stationDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.deliveryId}</TableCell>

													<TableCell onClick={row.rowClick}>{row.deliveryDateDisplay}</TableCell>

													<TableCell onClick={row.rowClick}>{row.deliveryInfo}</TableCell>

													<TableCell onClick={row.rowClick}>{row.documentInfo}</TableCell>

													<TableCell
														onClick={row.rowClick}
														className={classes[row.status]}
														style={{ whiteSpace: 'nowrap' }}
													>
														{row.statusDisplay}
													</TableCell>

													{canMakeUpdates && (
														<TableCell style={{ whiteSpace: 'nowrap' }}>
															<Button
																className={classes.button}
																onClick={() => this.handleEdit(row.stationInvoiceId)}
															>
																Edit
															</Button>
														</TableCell>
													)}
												</PureRecordRow>
											);
										})}
									</TableBody>
								</Table>
							</TabContainer>
						</SwipeableViews>

						<InvoiceDocumentPopup
							open={this.state.isInvoiceDocumentPopupOpen}
							onClose={this.handleCloseInvoiceDocumentPopup}
							invoiceDocuments={this.state.invoiceDocumentsPoppedUp}
							resourceMap={resourceMap}
						/>

						<InvoicePdfPopup
							open={this.state.isInvoicePdfPopupOpen}
							onClose={this.handleCloseInvoicePdfPopup}
							resourceId={this.state.invoicePdfPoppedUp}
							resourceMap={resourceMap}
						/>

						<ViewStationInvoiceLogDialog
							open={this.state.isViewDialogOpen}
							onClose={this.handleCloseViewDialog}
							stationInvoice={this.state.viewStationInvoice}
							history={this.props.history}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

StationInvoices.propTypes = {
	classes: PropTypes.object.isRequired,
	searchStationInvoices: PropTypes.func.isRequired,
	//stationInvoices : PropTypes.array,
	pendingStationInvoices: PropTypes.array,
	invalidStationInvoices: PropTypes.array,
	issuedStationInvoices: PropTypes.array,

	showErrors: PropTypes.func.isRequired,

	stationMap: PropTypes.object,
	supplierMap: PropTypes.object,
	carrierMap: PropTypes.object,
	terminalMap: PropTypes.object,
	resourceMap: PropTypes.object,
	invoiceDocumentMap: PropTypes.object,
	stationDeliveryMap: PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	canMakeUpdates: PropTypes.bool,
};

export default _.flow([withStyles(styles, { withTheme: true }), StationInvoicesContainer])(
	StationInvoices
);
